import React, { useEffect, useState } from 'react';

/**
 * Skeleton específico para páginas de autenticação (Login, Register, Landing)
 * Usa cores fixas light mode para evitar flash de tela preta durante transições
 * Com animação de fade-in suave
 */
export const AuthSkeleton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger fade-in animation after mount
    const timer = requestAnimationFrame(() => setIsVisible(true));
    return () => cancelAnimationFrame(timer);
  }, []);

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4 transition-opacity duration-300"
      style={{ 
        backgroundColor: '#f4f4f6',
        opacity: isVisible ? 1 : 0
      }}
    >
      <div className="w-full max-w-md space-y-6">
        {/* Logo placeholder */}
        <div className="flex justify-center">
          <div 
            className="h-16 w-48 rounded animate-pulse" 
            style={{ backgroundColor: '#e5e7eb' }}
          />
        </div>
        
        {/* Card placeholder */}
        <div 
          className="rounded-xl shadow-xl p-8 space-y-6"
          style={{ backgroundColor: '#ffffff' }}
        >
          {/* Title placeholder */}
          <div className="space-y-2">
            <div 
              className="h-8 w-32 mx-auto rounded animate-pulse" 
              style={{ backgroundColor: '#e5e7eb' }}
            />
            <div 
              className="h-4 w-48 mx-auto rounded animate-pulse" 
              style={{ backgroundColor: '#f3f4f6' }}
            />
          </div>
          
          {/* Input placeholders */}
          <div className="space-y-4">
            <div className="space-y-2">
              <div 
                className="h-4 w-16 rounded animate-pulse" 
                style={{ backgroundColor: '#e5e7eb' }}
              />
              <div 
                className="h-12 w-full rounded-lg animate-pulse" 
                style={{ backgroundColor: '#f3f4f6' }}
              />
            </div>
            <div className="space-y-2">
              <div 
                className="h-4 w-16 rounded animate-pulse" 
                style={{ backgroundColor: '#e5e7eb' }}
              />
              <div 
                className="h-12 w-full rounded-lg animate-pulse" 
                style={{ backgroundColor: '#f3f4f6' }}
              />
            </div>
          </div>
          
          {/* Button placeholder */}
          <div 
            className="h-12 w-full rounded-lg animate-pulse" 
            style={{ backgroundColor: '#3b82f6' }}
          />
          
          {/* Link placeholder */}
          <div className="flex justify-center">
            <div 
              className="h-4 w-40 rounded animate-pulse" 
              style={{ backgroundColor: '#f3f4f6' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthSkeleton;
